import {
  AccountType,
  BankNames
} from '../../../constants';
import { FieldTypes } from '../../../components/FormBuilder';

export const formInitialValues = {

};

export const registeredBusinessName = {
  type: 'text',
  inputMode: 'text',
  placeholder: 'Registered business name',
  name: 'accountHolderName',
  disabled: true,
  dark: false,
  hideUnderline: true
};

export const businessRegistrationNumber = {
  type: 'text',
  inputMode: 'text',
  name: 'businessRegistrationNumber',
  disabled: true,
  dark: false,
  hideUnderline: true
};

export const bankName = {
  placeholder: 'Bank',
  name: 'bankName',
  options: BankNames,
  scrollToTop: false
};

export const accountType = {
  placeholder: 'Account type',
  name: 'accountType',
  options: AccountType,
  scrollToTop: false
};

export const accountNumber = {
  placeholder: 'Account number',
  name: 'accountNumber',
  type: 'number',
  inputMode: 'number',
  disabled: false,
  dark: false,
  hideUnderline: true

};

export const formFields = (businessType) => {
  const idNumberPlaceholder = businessType !== 'Sole Proprietorship' ? 'Business registration number' : 'VAT number';
  return [
    {
      type: FieldTypes.INPUT,
      props: registeredBusinessName
    },
    {
      type: FieldTypes.INPUT,
      props: {
        ...businessRegistrationNumber,
        placeholder : idNumberPlaceholder
      }
    },
    {
      type: FieldTypes.SELECT,
      props: bankName
    },
    {
      type: FieldTypes.SELECT,
      props: accountType
    },
    {
      type: FieldTypes.INPUT,
      props: accountNumber
    }
  ];
};